import React from 'react';
import { strings } from '../../../resources/strings';
import { OrderLogType } from '../../../enums/OrderLogType';
import { OrderItem } from '../../../models/OrderItem';
import { OrderLog } from '../../../models/OrderLog';
import { Table } from '../../../common-components/Table/Table';
import { TableRow } from '../../../common-components/TableRow/TableRow';
import { TableHead } from '../../../common-components/TableHead/TableHead';
import { TableData } from '../../../common-components/TableData/TableData';
import { AssemblerQuantityPopover } from './AssemblerQuantityPopover';
import { Container } from './styles';

interface ITabItemsProps {
  items?: OrderItem[];
  assemblyHistory?: OrderLog[];
}

export const TabItems: React.FC<ITabItemsProps> = ({
  items,
  assemblyHistory
}) => {

  return (
    <Container>
      <Table>
        <thead>
          <TableRow>
            <TableHead width='130px'>{strings.Sku}</TableHead>
            <TableHead>{strings.Name}</TableHead>
            <TableHead width='95px' textAlign='center'>{strings.Quantity}</TableHead>
            <TableHead width='120px' textAlign='center'>Recebido</TableHead>
            <TableHead width='120px' textAlign='center'>Montando</TableHead>
            <TableHead width='120px' textAlign='center'>Montado</TableHead>
            <TableHead width='120px' textAlign='center'>Enviado Loja</TableHead>
          </TableRow>
        </thead>
        <tbody>
          {items?.filter(item => item.active)?.map(orderItem => {
            const itemIsNotActive = orderItem.canceledAt || orderItem.returnedAt || !orderItem.active;
            const textColor = itemIsNotActive ? 'red' : null;
            return (
              <TableRow key={`item-${orderItem.id}`}>
                <TableData textColor={textColor} data-id={orderItem.id}>{orderItem.sku}</TableData>
                <TableData textColor={textColor}>{orderItem.title}{orderItem.variantTitle ? ` - ${orderItem.variantTitle}` : ''}</TableData>
                <TableData width='95px' textAlign='center' textColor={textColor}>{orderItem.quantity}</TableData>
                <TableData textColor={textColor} textAlign='center'>
                  <AssemblerQuantityPopover
                    orderItemId={orderItem.id}
                    orderItemSku={orderItem.sku}
                    orderItemName={orderItem.name}
                    orderLogType={OrderLogType.AssemblerReceivedConfirmedByUser}
                    quantity={orderItem.assemblerReceivedConfirmedQuantity}
                    assemblyHistory={assemblyHistory}
                  />
                </TableData>
                <TableData textColor={textColor} textAlign='center'>
                  <AssemblerQuantityPopover
                    orderItemId={orderItem.id}
                    orderItemSku={orderItem.sku}
                    orderItemName={orderItem.name}
                    orderLogType={OrderLogType.AssemblyStartConfirmedByUser}
                    quantity={orderItem.assemblyStartConfirmedQuantity}
                    assemblyHistory={assemblyHistory}
                  />
                </TableData>
                <TableData textColor={textColor} textAlign='center'>
                  <AssemblerQuantityPopover
                    orderItemId={orderItem.id}
                    orderItemSku={orderItem.sku}
                    orderItemName={orderItem.name}
                    orderLogType={OrderLogType.AssemblyEndConfirmedByUser}
                    quantity={orderItem.assemblyEndConfirmedQuantity}
                    assemblyHistory={assemblyHistory}
                  />
                </TableData>
                <TableData textColor={textColor} textAlign='center'>
                  <AssemblerQuantityPopover
                    orderItemId={orderItem.id}
                    orderItemSku={orderItem.sku}
                    orderItemName={orderItem.name}
                    orderLogType={OrderLogType.SentToStoreConfirmedByUser}
                    quantity={orderItem.sentToStoreConfirmedQuantity}
                    assemblyHistory={assemblyHistory}
                  />
                </TableData>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );

};